export default "__VITE_ASSET__CI$SWr$I__"